var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FileDownload',{attrs:{"title":"안전보건 확보 의무","type":"image","isChange":_vm.hasAdminPermission}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }